import { HelpCircle } from "lucide-react";

interface HelpButtonProps {
  readonly onClick: () => void;
}

export function HelpButton({ onClick }: HelpButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="relative w-[38px] h-[38px] rounded-[10px] border border-sc-glass-border bg-sc-glass backdrop-blur-[10px] flex items-center justify-center text-sc-text-muted cursor-pointer hover:bg-sc-surface-hover transition-all"
      aria-label="Help"
      title="Help (press ? to toggle)"
    >
      <HelpCircle size={18} />
    </button>
  );
}
